import React, { useEffect, useMemo, useRef, useState } from 'react';

const awards = [
  {
    title: 'Hackathon Winner - Best Use of Hugging Face',
    org: 'Iterate x Mistral Worldwide Hackathon - NYC Edition',
    year: '2026',
    description: 'Won the "Best Use of Hugging Face" award for building a real-time digital twinning tool for the user demographics.',
  },
  {
    title: 'Hackathon Winner - 3rd Place and Best Use of Blaxel',
    org: 'Iterate x Columbia AI Club Hackathon',
    year: '2026',
    description: 'Won the 3rd place and the "Best Use of Blaxel" award for building autonomous agentic testing framework just from the Codebase.',
  },
  {
    title: 'Hackathon Winner - Best use of Dedalus Labs',
    org: 'Devfest 2026 - Columbia University',
    year: '2026',
    description: 'Won the "Best Use of Dedalus Labs" award for building MCP Adapter - MYME - Make Your MCP Easy.',
  },
  {
    title: 'Guest Lecturer - Capstone Project at Full Stack Development',
    org: 'Shiv Nadar University',
    year: '2025',
    description: 'Invited as the guest lecturer to conduct a entire course on full stack development and applications of AI sytems for scalability and security.',
  },
  {
    title: 'Hackathon Winner - Best use of Verbwire',
    org: 'Devfest 2025 - Columbia University',
    year: '2025',
    description: 'Won the "Best Use of Verbwire" award for building Grid Energy DAO - A blockchain based energy trading system from solar power.',
  },
  {
    title: 'First Class with Distinction',
    org: 'Shiv Nadar University',
    year: '2022',
    description: 'Graduated with First Class with Distinction in my undergraduate studies.',
  },
  {
    title: 'Secured Funding - Robotics Development',
    org: 'Shiv Nadar University',
    year: '2020',
    description: 'Secured funding and developed a 18DOF Hexapod for autonomous navigation and search and rescue.',
  },
];

const AwardsApp = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const shellRef = useRef(null);
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    if (!shellRef.current || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const updateLayoutMode = () => {
      const width = shellRef.current?.offsetWidth || 0;
      setIsCompact(width < 760);
    };

    updateLayoutMode();

    const observer = new ResizeObserver(updateLayoutMode);
    observer.observe(shellRef.current);

    return () => observer.disconnect();
  }, []);

  const activeAward = useMemo(() => awards[activeIndex] || awards[0], [activeIndex]);

  return (
    <div ref={shellRef} className={`awards-vault-shell${isCompact ? ' is-compact' : ''}`}>
      <div className="awards-vault-header">
        <div>
          <p className="awards-vault-kicker">Recognition</p>
          <h2 className="awards-vault-title">A wall of wins, not a plain list.</h2>
          <p className="awards-vault-copy">
            These are the moments where the work turned into proof: hackathons, teaching, and research-adjacent wins that shaped the story.
          </p>
        </div>
        <div className="awards-vault-count">{awards.length} milestones</div>
      </div>

      <div className="awards-vault-layout">
        <div className="awards-vault-gallery-wrapper">
          <div className="awards-vault-gallery">
            {awards.map((award, index) => {
              const active = index === activeIndex;
              return (
                <button
                  key={`${award.title}-${index}`}
                  type="button"
                  className={`awards-vault-card${active ? ' active' : ''}`}
                  onClick={() => setActiveIndex(index)}
                >
                  <span className="awards-vault-card-year">{award.year}</span>
                  <span className="awards-vault-card-title">{award.title}</span>
                  <span className="awards-vault-card-org">{award.org}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="awards-vault-feature" style={{ '--vault-accent': '#FFD54F' }}>
          <div className="awards-vault-medal">
            <span className="awards-vault-medal-ring" />
            <span className="awards-vault-medal-year">{activeAward.year}</span>
          </div>
          <div className="awards-vault-feature-copy">
            <p className="awards-vault-feature-kicker">{activeAward.org}</p>
            <h3 className="awards-vault-feature-title">{activeAward.title}</h3>
            <p className="awards-vault-feature-desc">{activeAward.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwardsApp;
